// Imports => React
import React, {useMemo, memo} from 'react';
import {Props} from './ac-rich-content.proptypes';
import clsx from 'clsx';

const _CLASSES = {
  MAIN: 'ac-rich-content',
  BLOCK: 'ac-rich-content--block',
};

// Component
const AcRichContent = memo(({content, block = false, className}) => {
  const getStyleClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN, block && _CLASSES.BLOCK, className && className);
  }, [block, className]);

  return (
    <div
      className={getStyleClassNames}
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  );
});

AcRichContent.displayName = 'AcRichContent';
AcRichContent.propTypes = Props;

export {AcRichContent};
export default AcRichContent;
